import * as React from 'react';
import { connect } from 'react-redux';
import AutosizerFlex from 'components/AutosizerFlex';
import { ContainerProps, DimensionChartProps } from './types';
import { DecisionPivotGrid } from './graphs/TableChart/DecisionPivotGrid';
import NumberChart from './graphs/NumberChart';
import ParagraphChart from './graphs/ParagraphChart';
import GaugeChart from './graphs/GaugeChart';
import PieChart from './graphs/RoundCharts/PieChart';
import DonutChart from './graphs/RoundCharts/DonutChart';
import LineChart from './graphs/LineChart';
import BarChart from './graphs/BarCharts/BarChart';
import HorizontalBarChart from './graphs/BarCharts/HorizontalBarChart';
import PolarBarChart from './graphs/BarCharts/PolarBarChart';
import AreaChart from './graphs/AreaChart';
import TreemapChart from './graphs/TreemapChart';
import ScatterplotChart from './graphs/ScatterplotChart';
import MapChart from './graphs/MapChart';
// Advanced type of chart, not available to users right now
import AdvancedChart from './graphs/AdvancedChart';
import PyramidChart from './graphs/BarCharts/PyramidChart';

import './_chart.scss';
import TableAgChart from './graphs/TableChart/TableAgChart';
import { RootState } from 'store/store';

const visMap = {
    number: NumberChart,
    gauge: GaugeChart,
    table: TableAgChart,
    pivot_table: DecisionPivotGrid,
    pie: PieChart,
    donut: DonutChart,
    bar: BarChart,
    horizontal_bar: HorizontalBarChart,
    polar_bar: PolarBarChart,
    line: LineChart,
    area: AreaChart,
    treemap: TreemapChart,
    scatterplot: ScatterplotChart,
    map: MapChart,
    advanced: AdvancedChart,
    paragraph: ParagraphChart,
    pyramid: PyramidChart,
};

/** The DimensionChart manages the height, width and resizing of a chart.
 * It also calls the relevant graph viz components depending to the requested vizualisation.
 */

const DimensionChart = ({
    height,
    width,
    vizType,
    isPngModeActivated,
    orderedColumns,
    showDetailsModal,
    applyChartSettings = null,
    isPdfModeActivated = false,
    ...props
}: DimensionChartProps) => {
    if (height === 0 || width === 0) {
        // this avoid a "growing" effect on first render
        return <span />;
    }
    const ChartType = visMap[vizType];
    const chartProps = {
        ...props,
        hideSideBar: isPngModeActivated || isPdfModeActivated,
        height: height,
        width: width,
        orderedColumns: orderedColumns,
        onClick: showDetailsModal,
        applyChartSettings: applyChartSettings,
    };
    // @ts-expect-error the props passed to the chart are complex and depends on the chart type
    // I have no idea how to type this
    return <ChartType {...chartProps} />;
};
/** The flex dimension chart is a growing flex component.
 * Its direct father should be a `display: flex;` component.
 * */
const FlexDimensionChart = (chartProps: ContainerProps) => (
    <AutosizerFlex>
        {(sizeProps) => <DimensionChart {...chartProps} {...sizeProps} />}
    </AutosizerFlex>
);

const mapStateToProps = (state: RootState) => ({
    isPdfModeActivated: state.vision.isPdfModeActivated,
});

export default connect(mapStateToProps)(FlexDimensionChart);
